




































import { Employee } from "@/api";
import shifts from "@/common/shift_type";
import { Component, Vue } from "vue-property-decorator";
import Loading from "@/components/loader/loading.vue";
import { generateCompanyMembersPDF } from "@/tool/pdfTools";
import moment from "moment";

@Component({
  components: {
    Loading,
  },
})
export default class StatisticsBreakdown extends Vue {
  loading = false;
  title = this.$route.query.title as string;
  employeeList: {
    profile: string;
    name: string;
    department: string;
    phone: string;
    email: string;
    title: string;
    shift: string;
    initials: string;
  }[] = [];
  headers = [
    {
      text: "Profile",
      align: "start",
      sortable: false,
      value: "profile",
    },
    { text: "Name", align: "start", sortable: false, value: "name" },
    {
      text: "Primary Department",
      align: "center",
      sortable: false,
      value: "department",
    },
    { text: "Phone", align: "center", sortable: false, value: "phone" },
    { text: "Email", align: "center", sortable: false, value: "email" },
    { text: "Title", align: "center", sortable: false, value: "title" },
    { text: "Shift", align: "end", sortable: false, value: "shift" },
  ];

  async created() {
    this.loading = true;
    const payload = {
      departmentId: this.$route.query.departmentId,
      titleId: this.$route.query.titleId,
      shift: this.$route.query.shift,
    };
    await this.$store.dispatch("facility/fetchEmployees", payload);
    this.loading = false;
  }

  get employees() {
    const list =
      (this.$store.getters["facility/employees"] as Array<Employee>) || [];

    this.employeeList = list.map(employee => {
      const initials = `${employee.firstName?.[0] || "N"}${employee
        .lastName?.[0] || "A"}`;

      return {
        profile: employee.profilePicture || "",
        name: `${employee.firstName} ${employee.lastName}`,
        department: this.getDepartmentName(employee),
        phone: employee.phone || "N/A",
        email: employee.email || "N/A",
        title: employee.title || "N/A",
        shift: this.getShift(employee),
        initials: `${initials}`,
      };
    });
    return this.employeeList;
  }

  getDepartmentName(employee: Employee): string {
    const department = employee.departmentAssignments.find(
      assignment => assignment.departmentId == employee.primaryDepartmentId,
    );

    return department?.departmentName ?? "No Department";
  }

  getShift(employee: Employee): string {
    const shift = shifts().find(item => item.id == employee.shift);
    return shift?.name || "Shift not confirmed";
  }

  async downloadHandler() {
    const doc = await generateCompanyMembersPDF(
      this.title || "Facility",
      this.employeeList,
    );

    doc.save(`Facility-${this.title}-${moment().format("MM/DD/YYYY")}.pdf`);
  }
}
